import { LoadingButton } from '@mui/lab'
import { Checkbox, FormControl, Grid, InputAdornment, InputLabel, MenuItem, Select, Skeleton, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, TextField } from '@mui/material'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import React, { useEffect, useState } from 'react'
import { useNotify, useTranslate } from 'react-admin'
import { EditInputsWrap } from 'src/components/uiElements/CRUD/EditInputsWrap'
import { billingFormServices } from 'src/services/payment/billingForm/billingForm.service'
import EditIcon from '@mui/icons-material/Edit';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
import DeleteIcon from '@mui/icons-material/Delete';
import { ConfirmationDialog } from 'src/components/uiElements/styledComponents/ConfirmationDialog'
import { hasPermissionFunction } from 'src/helper/HasPermission'


export const ConciliationList = () => {
    const translate = useTranslate()
    const notify = useNotify()
	const [selectedBank, setSelectedBank] = useState(null)
	const [bankExtracts, setBankExtracts] = useState([])
    const [loadingExtracts, setLoadingExtracts] = useState(false)
    const [dateFilter, setDateFilter] = useState({from:null, to:null})
    const [conciliableFilter, setConciliableFilter] = useState(false)
    const [paginationItemData, setPaginationItemData] = useState({ page: 0, rowsPerPage: 10 })
    const [total, setTotal] = useState(0)
    const [openConfirmDelete, setOpenConfirmDelete] = useState(false)
    const [confirmDelete, setConfirmDelete] = useState(false)
    const [hashToDelete, setHashToDelete] = useState('')
    const [loadingDelete, setLoadingDelete] = useState(false)

    useEffect(()=>{
        if(confirmDelete){
            onDeleteExtract()
        }
    },[confirmDelete])

    const onDeleteExtract = async () =>{
        setLoadingDelete(true)
        await billingFormServices.deleteExtractBank(selectedBank, hashToDelete).then(()=>{
            notify('ra.notification.delete_extract_success',{type:'success'})
            getBankExtracts()
        }).catch(()=>{
            notify('ra.notification.delete_extract_error',{type:'error'})
        }).finally(()=>{
            setLoadingDelete(false)
            setConfirmDelete(false)
            setOpenConfirmDelete(false)
        })
    }

    const getBankExtracts = async () =>{
        setLoadingExtracts(true)
		const foundExtracts = await billingFormServices.getBankExtracts({
            bank_name:selectedBank, 
            date_filter_from:dateFilter.from,
            date_filter_to:dateFilter.to,
            conciliable_filter:conciliableFilter,
            page:paginationItemData.page,
            page_size:paginationItemData.rowsPerPage
        })
        if(foundExtracts){
            setLoadingExtracts(false)
            setBankExtracts(foundExtracts.data.data)
            setTotal(foundExtracts.data.total)
        }
	}

    const onPageItemChange = (number) => {
        const paginationItemDataAux = { ...paginationItemData }
        paginationItemDataAux.page = number
        setPaginationItemData(paginationItemDataAux)
    }

    const onRowsPerPageItemChange = (e) => {
        const paginationItemDataAux = { ...paginationItemData }
        paginationItemDataAux.rowsPerPage = parseInt(e.target.value, 10)
        paginationItemDataAux.page = 0
        setPaginationItemData(paginationItemDataAux)
    }

    const CustomCheckbox =({extractValue, hashId}) =>{
        const [isChecked, setIsChecked] = useState(extractValue)
        const [loadingUpdate, setLoadingUpdate] = useState(false)

        const updateConciliation = async (hash_id) =>{
            setLoadingUpdate(true)
            await billingFormServices.updateBankExtract({bank_name:selectedBank, hash_id}).then(()=>{
                setIsChecked(val=>!val)
                notify('ra.notification.edit_extract_success',{type:'success'})
            }).catch(()=>{
                notify('ra.notification.edit_extract_error',{type:'error'})
            }).finally(()=>{
                setLoadingUpdate(false)
            })
        }

        return(
            <>
                {loadingUpdate ? 
                    <Skeleton/>
                    :
                <Checkbox 
                    checked={isChecked} 
                    onClick={()=>{updateConciliation(hashId)}}
                />}
            </>
        )
    }

    const EditableField = ({extractValue, hash_id, field}) =>{
        const [isEditable, setIsEditable] = useState(false)
        const [conceptValue, setConceptValue] = useState(extractValue)
        const [loadingUpdate, setLoadingUpdate] = useState(false)

        const updateConcept = async () =>{
            setLoadingUpdate(true)
            await billingFormServices.updateBankExtract({
                bank_name:selectedBank, 
                hash_id, 
                extract_field:field, 
                extract_value:conceptValue
            }).then(()=>{
                setIsEditable(false)
                notify('ra.notification.edit_extract_success',{type:'success'})
            }).catch(()=>{
                notify('ra.notification.edit_extract_error',{type:'error'})
            }).finally(()=>{
                setLoadingUpdate(false)
            })
        }

        return(
            <>
                {
                    isEditable ?
                    !loadingUpdate ?
                    <TextField
                        fullWidth
                        value={conceptValue}
                        size='small'
                        onChange={(val)=>setConceptValue(val.target.value)}
                        InputProps={{
                            endAdornment: (
                            <InputAdornment position="end">
                                <DoneIcon fontSize='small' color='success' style={{cursor:'pointer'}} onClick={updateConcept}  />
                                <CloseIcon fontSize='small' color='error' style={{cursor:'pointer'}} onClick={()=>setIsEditable(false)}  />
                            </InputAdornment>
                            ),
                        }}
                    />
                    :
                    <Skeleton/>
                    :
                    <label style={{display:'flex', flexDirection:'row', alignItems:'center', justifyContent:'space-between'}}>
                        {conceptValue}
                        <EditIcon fontSize='small' style={{cursor:'pointer'}} onClick={()=>setIsEditable(true)} />
                    </label>
                }
            </>
        )
    }

	useEffect(()=>{
		if(selectedBank && dateFilter.to && dateFilter.from){
			getBankExtracts()
		}
	},[selectedBank, dateFilter, conciliableFilter, paginationItemData])

  return (
    <Grid container spacing={3} className='pageCard'>
        {/* <FormControl fullWidth> */}
            {/* <InputLabel id="bank-label">{translate('ra.field.bank')}</InputLabel> */}
            <EditInputsWrap label={translate('ra.field.bank')} xs={12} sm={4} md={4} lg={4} xl={4}>
                <Select
                    labelId="bank-label"
                    value={selectedBank}
                    fullWidth
                    size='small'
                    label="Edad"
                    onChange={(val)=>setSelectedBank(val.target.value)}
                >	
                    <MenuItem key={2} value={'PATARS'}>Banco Patagonia</MenuItem>
                    <MenuItem key={3} value={'RIOARS'}>Banco Santander (pesos)</MenuItem>
                    <MenuItem key={4} value={'RIOUSD'}>Banco Santander (dólares)</MenuItem>
                    <MenuItem key={3} value={'BASEUSD'}>Banco Base (dólares)</MenuItem>
                    <MenuItem key={4} value={'BASEMXN'}>Banco Base (pesos mexicanos)</MenuItem>
                    <MenuItem key={3} value={'MACUSD'}>Banco Macro (dólares)</MenuItem>
                </Select>
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.from')} xs={12} sm={4} md={4} lg={4} xl={4}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
                    <DatePicker
                        value={dateFilter.from || null}
                        id='date'
                        onChange={(date) => setDateFilter(prevDate=>({...prevDate, from:date}))}
                        renderInput={(params) => (
                            <TextField {...params} required  style={{width:'100%'}} fullWidth variant='outlined' size='small' />
                        )}
                    />
                </LocalizationProvider>
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.to')} xs={12} sm={4} md={4} lg={4} xl={4}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
                    <DatePicker
                        value={dateFilter.to || null}
                        id='date'
                        onChange={(date) => setDateFilter(prevDate=>({...prevDate, to:date}))}
                        renderInput={(params) => (
                            <TextField {...params} required  style={{width:'100%'}} fullWidth variant='outlined' size='small' />
                        )}
                    />
                </LocalizationProvider>
            </EditInputsWrap>
            <EditInputsWrap label={translate('ra.field.no_conciled')} xs={12} sm={4} md={4} lg={4} xl={4}>
                <Switch  
                    value={conciliableFilter}
                    onClick={()=>setConciliableFilter(val=>!val)}
                />
            </EditInputsWrap>
        {/* </FormControl> */}
        {(bankExtracts.length > 0 || loadingExtracts) &&
            <TableContainer>
                <Table>
                    <TableHead>
                        {loadingExtracts ? (
                            <TableRow>
                            {[...Array(6)].map((_, i) => (
                                <TableCell key={i}>
                                    <Skeleton variant='rectangular' width={'100%'} height={20} />
                                </TableCell>
                            ))}
                            </TableRow>
                        ) :
                        <TableRow>
                            {Object.keys(bankExtracts[0]).map(bankKey=>(
                                bankKey !== 'HashId' && bankKey !== 'Duplicates' &&
                                <TableCell>
                                    {bankKey}
                                </TableCell>
                            ))}
                        </TableRow>
                    }
                    </TableHead>
                    <TableBody>
                        {loadingExtracts ? (
                            <TableRow>
                            {[...Array(6)].map((_, i) => (
                                <TableCell key={i}>
                                    <Skeleton variant='rectangular' width={'100%'} height={20} />
                                </TableCell>
                            ))}
                            </TableRow>
                        ) :
                        bankExtracts.map(extract=>(
                            <TableRow>
                                {Object.values(extract).map((extractValue, index)=>(
                                    Object.keys(bankExtracts[0])[index] !== 'HashId' && Object.keys(bankExtracts[0])[index] !== 'Duplicates' &&
                                    <TableCell sx={{
                                            whiteSpace: 'nowrap',
                                            overflowWrap: 'break-word'
                                        }}>
                                            {
                                                Object.keys(extract)[index] === 'Conciliado' ?
                                                
                                                <CustomCheckbox extractValue={extractValue} hashId={extract.HashId}/> :

                                                Object.keys(extract)[index] === 'Concepto' || Object.keys(extract)[index] === 'NroFormulario' ?
                                                <EditableField extractValue={extractValue} hash_id={extract.HashId} field={Object.keys(extract)[index]}/>
                                                :
                                                extractValue
                                            }

                                    </TableCell>
                                ))}
                                <TableCell>
                                    <DeleteIcon 
                                        color={hasPermissionFunction('bilingform_conciliation','delete') ?'error':'disabled' }
                                        style={{
                                            cursor: hasPermissionFunction('bilingform_conciliation','delete') ? 
                                            'pointer': 'inherit'
                                        }}
                                        onClick={()=>{
                                            if(hasPermissionFunction('bilingform_conciliation','delete')){
                                                setHashToDelete(extract.HashId)
                                                setOpenConfirmDelete(true)
                                            }
                                        }} />
                                </TableCell>
                            </TableRow>
                        ))}
                        
                    </TableBody>
                    <TableFooter>
                        <TableRow>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 25, 50]}
                            count={total}
                            rowsPerPage={paginationItemData.rowsPerPage}
                            page={paginationItemData.page}
                            onPageChange={(e, number) => onPageItemChange(number)}
                            onRowsPerPageChange={(e) => onRowsPerPageItemChange(e)}
                            labelRowsPerPage={translate('ra.navigation.page_rows_per_page')}
                            labelDisplayedRows={({ from, to, count }) =>
                            `${from}–${to} ${translate('ra.navigation.of')} ${count}`
                            }
                        />
                        </TableRow>
                    </TableFooter>
                </Table>
            </TableContainer>
        }
        <ConfirmationDialog
            open={openConfirmDelete}
            setOpen={setOpenConfirmDelete}
            setConfirm={setConfirmDelete}
            contentText={translate('ra.message.delete_bank_extract')}
            loadingModalButton={loadingDelete}
            buttonCancel={translate('ra.action.cancel')}
            buttonConfirmText={translate('ra.action.to_confirm')}
        />
    </Grid>
  )
}
